import { BadgePaymentStatus, ChipStatus } from "../../../../common/enums";
import startCase from "lodash.startcase";
import Chip from "@mui/material/Chip";
import colors from "../../../../common/styles/colors";
import camelCase from "lodash.camelcase";

type Props = {
  status: ChipStatus | BadgePaymentStatus;
  label?: string;
  overrideBackgroundColor?: string;
};

const styles = {
  chipContainer: {
    width: "fit-content",
    fontSize: "13px !important"
  },
  active: {
    backgroundColor: colors.green["100"],
    color: colors.green["900"]
  },
  inactive: {
    backgroundColor: colors.white,
    border: `1px solid ${colors.lightGrey11}`
  },
  deactivated: {
    backgroundColor: colors.yellow["200"],
    color: colors.yellow["800"]
  },
  cancelled: {
    backgroundColor: colors.red['100'],
    color: colors.red["800"]
  },
  rejected: {
    backgroundColor: colors.red['100'],
    color: colors.red["800"]
  },
  pending: {
    backgroundColor: colors.yellow["200"],
    color: colors.yellow["800"]
  },
  paid: {
    backgroundColor: 'transparent',
    border: '1px solid lightgrey'
  },
  free: {
    backgroundColor: 'transparent',
    border: '1px solid lightgrey'
  },
  unpaid: {
    backgroundColor: colors.yellow["200"],
    color: colors.yellow["800"]
  },
  unpaidOverridden: {
    backgroundColor: colors.yellow["200"],
    color: colors.yellow["800"]
  }
};

export const StatusChip = ({ status, label, overrideBackgroundColor }: Props) => {
  const chipStyles = styles[camelCase(status?.toLowerCase())];

  if (overrideBackgroundColor) {
    chipStyles.backgroundColor = overrideBackgroundColor;
  }

  return <Chip data-testid="status-chip" label={label || startCase(status)} sx={{ ...chipStyles, ...styles.chipContainer }} />;
};
